<template>
  <div class="tw:flex tw:flex-col tw:gap-2 tw:p-4">
    <Checkbox
      v-for="type in types"
      :key="type.field"
      v-model="localSelectedTypes"
      :color="checkboxColor"
      :data-testid="`option-${type.field}`"
      dense
      :label="type.appLabel"
      new-design
      :value="type.field"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Checkbox from "shared/components/core/forms/Checkbox.vue";
import {
  type RelatedType,
  defaultContentToggles,
  getSourceByField,
  MediumField,
} from "shared/helpers/media";
import { type Stream } from "shared/types";
import {
  type MentionType,
  type SocialMentionType,
} from "shared/types/mentions";

const selectedTvContent = defineModel<MentionType[]>("selectedTvContent", {
  default: () => [],
});

const selectedSocialContent = defineModel<SocialMentionType[]>(
  "selectedSocialContent",
  {
    default: () => [],
  }
);

interface StreamFiltersMediaMentionTypesProps {
  stream: Stream;
  medium: MediumField;
}

const props = defineProps<StreamFiltersMediaMentionTypesProps>();

const checkboxColor = computed(() => String(props.medium));

const localSelectedTypes = computed<MentionType[] | SocialMentionType[]>({
  get() {
    if (props.medium === MediumField.TV) {
      if (selectedTvContent.value.length) {
        return selectedTvContent.value;
      }

      return props.stream.selected_tv_content?.length
        ? props.stream.selected_tv_content
        : [];
    }

    if (props.medium === MediumField.SOCIAL) {
      if (selectedSocialContent.value.length) {
        return selectedSocialContent.value;
      }

      return props.stream.selected_social_content?.length
        ? props.stream.selected_social_content
        : [];
    }

    return [];
  },
  set(value: MentionType[] | SocialMentionType[]) {
    if (props.medium === MediumField.TV) {
      selectedTvContent.value = value as MentionType[];
    }

    if (props.medium === MediumField.SOCIAL) {
      selectedSocialContent.value = value as SocialMentionType[];
    }
  },
});

const enabledTypes = computed<string[]>(() => {
  const contentTypes = defaultContentToggles();

  return contentTypes[`selected_${props.medium}_content`] || [];
});

const types = computed<RelatedType[]>(() => {
  const mediumByField = getSourceByField(props.medium);

  return mediumByField.relatedTypes.filter((type) =>
    enabledTypes.value.includes(type.field)
  );
});
</script>
